import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { PasswordResetComponent } from './password-reset/password-reset.component';
import { DriverRouteComponent } from './admin-dashboard/driver-route/driver-route.component';
import { AdminLoginComponent } from './admin-dashboard/admin-login/admin-login.component';
import { PassengerMapScreenComponent } from './shared/passenger-map-screen/passenger-map-screen.component';
import { ViewTripRouteComponent } from './shared/view-trip-route/view-trip-route.component';
import { GAuthorizationCallbackComponent } from './g-authorization-callback/g-authorization-callback.component';
import { DriverRegistrationComponent } from './driver-registration/driver-registration.component';
import { DriverGAuthorizationCallbackComponent } from './driver-g-authorization-callback/driver-g-authorization-callback.component';
import { TermsComponent } from './terms/terms.component';
import { RegistrationCompleteComponent } from './registration-complete/registration-complete.component';
import { ClientLoginComponent } from './client-login/client-login.component';
import { ClaimAccountComponent } from './claim-account/claim-account.component';
import { AuthGuard } from './user-dashboard/AuthGuard/AuthGuard';
import { HomeComponent } from './home/home.component';
import { BookRideComponent } from './book-ride/book-ride.component';
import { SupportComponent } from './support/support.component';
import { StatusUpdateComponent } from './status-update/status-update.component';
import { CourierOnboardingComponent } from './admin-dashboard/courier-onboarding/courier-onboarding.component';

const routes: Routes = [
  { path: 'dashboard', redirectTo: '/dashboard', pathMatch: 'full' },
  {
    path:'',
    redirectTo:'user/login',
    pathMatch:'full'
  },
  {
    path: 'request-ride',
    component: HomeComponent
  },
  {
    path:'support',
    component: SupportComponent
  },
  {
    path:'book-ride',
    component: BookRideComponent
  },
  {
    path: 'client-login',
    component: ClientLoginComponent
  },
  {
    path: 'claim',
    component: ClaimAccountComponent
  },
  {
    path: 'user/login',
    component: LoginComponent
  },
  {
    path: 'user/register/:id',
    component: RegisterComponent
  },
  {
    path: 'user/register',
    component: RegisterComponent
  },
  {
    path: 'registration-complete',
    component: RegistrationCompleteComponent
  },
  {
    path: 'driver-register',
    component: DriverRegistrationComponent
  },
  {
    path: 'driver/register',
    component: DriverRegistrationComponent
  },
  {
    path: 'user/password-reset/:id',
    component: PasswordResetComponent
  },
  {
    path: 'terms-policy',
    component: TermsComponent,
  },
  {
    path: 'route',
    component: DriverRouteComponent
  },
  {
    path: 'admin-portal/login',
    component: AdminLoginComponent
  },
  {
    path: 'courier-onboarding',
    component: CourierOnboardingComponent
  },
  {
    path: 'tracking-link',
    component: StatusUpdateComponent
  },
  {
    path: 'g-authorization-callback',
    component: GAuthorizationCallbackComponent
  },
  {
    path: 'driver-g-authorization-callback',
    component: DriverGAuthorizationCallbackComponent
  },
  {
    path: 'picker',
    component: PassengerMapScreenComponent
  },
  { path: 'view-route/:tripid', component: ViewTripRouteComponent },
  {
    path: 'admin-portal',
    loadChildren: './admin-dashboard/admin-dashboard.module#AdminDashboardModule'
  },
  {
    path: 'client-portal',
    loadChildren: './client-dashboard/client-dashboard.module#ClientDashboardModule'
  },
  {
    path: 'user-portal',
    canActivate: [AuthGuard],
    loadChildren: './user-dashboard/user-dashboard.module#UserDashboardModule'
  },
  {
    path:'store',
    loadChildren:'./vendor-portal/vendor-portal.module#VendorPortalModule'
  },
];


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  providers: [
    AuthGuard
  ],
  exports: [RouterModule]
})

export class AppRoutingModule {

}
